module.exports = __webpack_public_path__ + "img/instagram.48898b66.svg";